import { Button, Label, TextInput } from 'flowbite-react';
import { useState } from 'react';

export type ProvideWalletsModalProps = {
  onConfirm: (params: {
    walletAddress: string;
    comment?: string;
  }) => void | Promise<void>;
  onCancel: () => void;
};

export const ProvideWalletsModal = ({
  onConfirm,
  onCancel,
}: ProvideWalletsModalProps) => {
  const [walletAddress, setWalletAddress] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState<string | null>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setError(null);
    const trimmed = walletAddress.trim();
    if (!trimmed) {
      setError('Введите адрес кошелька');
      return;
    }
    setIsSubmitting(true);
    try {
      await onConfirm({
        walletAddress: trimmed,
        comment: comment.trim() || undefined,
      });
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось сохранить');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="provide-wallets-address" className="mb-2 block">
          Криптокошелёк, куда планируется перевод
        </Label>
        <TextInput
          id="provide-wallets-address"
          type="text"
          placeholder="Введите адрес кошелька"
          value={walletAddress}
          onChange={(e) => setWalletAddress(e.target.value)}
          className="w-full"
        />
      </div>
      {/* <div>
        <Label htmlFor="provide-wallets-comment" className="mb-2 block">
          Комментарий
        </Label>
        <Textarea
          id="provide-wallets-comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Необязательно"
          rows={3}
          className="w-full"
        />
      </div> */}
      {error && <p className="text-sm text-red-600">{error}</p>}
      <div className="flex gap-4 border-t border-gray-200 pt-4">
        <Button color="primary" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Сохранение...' : 'Сохранить'}
        </Button>
        <Button color="light" onClick={onCancel} disabled={isSubmitting}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
